import { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"
import type { IInstructionFeedbackActivity } from "@/interfaces/api/instruction-feedback-activity.interface"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { InstructionFeedbackActivityRepository } from "@/repositories/instruction-feedback-activity-repository"
import { useInstructionFeedbacksActivitiesStore } from "@/store/instruction-feedbacks-activities.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import type { InstructionFeedback } from "@/models/instruction-feedback.model"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class InstructionFeedbackActivityController extends GenericModelController<
  InstructionFeedbackActivity,
  IInstructionFeedbackActivity,
  InstructionFeedbackActivityRepository
> {
  constructor() {
    const {
      pushToRelatedAppInstructions,
      removeFromRelatedAppInstructions,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions
    } = useInstructionFeedbacksActivitiesStore()
    const storeFunctionsConfig = {
      onCreate: (instructionFeedbackActivity: InstructionFeedbackActivity) => {
        pushToRelatedAppInstructions(instructionFeedbackActivity)
        pushToRelatedPlanningInstructions(instructionFeedbackActivity)
      },
      onDelete: (instructionFeedbackActivity: InstructionFeedbackActivity) => {
        removeFromRelatedAppInstructions(instructionFeedbackActivity)
        removeFromRelatedPlanningInstructions(instructionFeedbackActivity)
      }
    }

    super(
      InstructionFeedbackActivity,
      storeFunctionsConfig,
      new InstructionFeedbackActivityRepository()
    )
    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      InstructionFeedbackActivity,
      null,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions,
      false
    )
  }

  public async createActivityForInstructionFeedback(
    instructionFeedback: InstructionFeedback,
    instructionFeedbackActivity: InstructionFeedbackActivity,
    requestConfig?: IRepositoryRequestConfig
  ) {
    instructionFeedbackActivity.instructionFeedback = instructionFeedback.id
    return this.create(instructionFeedbackActivity, requestConfig)
  }
}
